<div class="container-fluid spacer-top-navigation savings-plan">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <web-components-user-notes target="savingsplan" [dismissibleNotes]="true" />
      </div>
    </div>
    <saving-plans-saving-plan-existing-plans
      [savingPlans]="savingPlansFacade.savingsPlans$ | async"
      [savingsPlansDirectDebitActive]="savingPlansFacade.savingsPlansDirectDebitActive$ | async"
    />
    <div class="row same-height">
      <div class="col-md-12 col-xl-8 mb-4 mb-xl-0">
        <saving-plans-saving-plan-suggestions />
      </div>
      <div class="col-md-12 col-xl-4 mb-54mb-xl-0">
        <saving-plans-saving-plan-most-chosen-list />
      </div>
    </div>
    <div class="spacer-default hidden-xs hidden-sm hidden-md"></div>
    <saving-plans-saving-plan-subjects />
  </div>
</div>
